export const seriespatternMenuDef = [

  {
    "name": "menu.series_pattern",
    "icon": "fa fa-tags",
    "data": {
      "nav_url": "seriesPattern_uhid_m"
    },
    "children": [
      {
        "name": "menu.seriesPattern_universal",
        "resource": "seriesPattern_universal",
        "icon": "fa fa-tag",
        "url": "seriesPattern_universal",
        "auto_crud": true,
        "breadcrumb": "Universal Pattern"
      },
      {
        "name": "menu.uhid_pattern",
        "resource": "seriesPattern_uhid",
        "icon": "fa fa-tag",
        "url": "seriesPattern_uhid",
        "auto_crud": true,
        "breadcrumb": "Uhid Pattern"
      },
      {
        "name": "menu.visit_pattern",
        "resource": "seriesPattern_visit",
        "icon": "fa fa-tag",
        "url": "seriesPattern_visit",
        "auto_crud": true,
        "breadcrumb": "Visit Pattern"
      },
      {
        "name": "menu.seriesPattern_ehc",
        "resource": "seriesPattern_ehc",
        "icon": "fa fa-user-md",
        "url": "seriesPattern_ehc",
        "auto_crud": true,
        "breadcrumb": "seriesPattern Ehc",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.seriesPattern_phc",
        "resource": "seriesPattern_phc",
        "icon": "fa fa-user-md",
        "url": "seriesPattern_phc",
        "auto_crud": true,
        "breadcrumb": "seriesPattern phc",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.transaction_pattern",
        "resource": "seriesPattern_transaction",
        "icon": "fa fa-tag",
        "url": "seriesPattern_transaction",
        "auto_crud": true,
        "breadcrumb": "Transaction Pattern"
      },
      {
        "name": "menu.pharmacy_transaction_pattern",
        "resource": "seriesPattern_pharmacy_transaction",
        "icon": "fa fa-tag",
        "url": "seriesPattern_pharmacy_transaction",
        "auto_crud": true,
        "breadcrumb": "Pharmacy Transaction Pattern"
      },
      {
        "name": "PRN Pattern",
        "resource": "account_seriesPattern_prn",
        "icon": "fa fa-tag",
        "url": "account_seriesPattern_prn",
        "auto_crud": true,
        "breadcrumb": "PRN Pattern"
      },
      {
        "name": "Universal Pattern",
        "resource": "account_seriesPattern_universal",
        "icon": "fa fa-tag",
        "url": "account_seriesPattern_universal",
        "auto_crud": true,
        "breadcrumb": "Universal Pattern"
      },
      {
        "name": "TRN Pattern",
        "resource": "account_seriesPattern_trn",
        "icon": "fa fa-tag",
        "url": "account_seriesPattern_trn",
        "auto_crud": true,
        "breadcrumb": "TRN Pattern"
      },
      {
        "name": "Diagnostic Transaction Pattern",
        "resource": "diagnostic_transaction_pattern",
        "icon": "fa fa-tag",
        "url": "diagnostic_transaction_pattern",
        "auto_crud": true,
        "breadcrumb": "Diagnostic Transaction Pattern"
      },
      {
        "name": "MRD Transaction Pattern",
        "resource": "mrd_transaction_pattern",
        "icon": "fa fa-tag",
        "url": "mrd_transaction_pattern",
        "auto_crud": true,
        "breadcrumb": "MRD Transaction Pattern"
      },
      {
        "name": "seriesPattern_qms",
        "resource": "seriesPattern_qms",
        "url": "seriesPattern_qms",
        "auto_crud": true,
        "breadcrumb": "seriesPattern_qms"
      }, 
      {
        "name": "Universal Pattern",
        "resource": "helpdesk_account_seriesPattern",
        "icon": "fa fa-tag",
        "url": "helpdesk_account_seriesPattern",
        "auto_crud": true,
        "breadcrumb": "Universal Pattern"
      }
    ]
  } 
]
